import { getWorkflowConfig } from '@/components/WorkflowStatusChips';
import { DOT } from '@/components/Page';
import { formatData, formatHora } from '@/lib/format';

// Linha do tempo do pedido (Pedidos e Gestão de pedidos). Hora à esquerda,
// ponto na cor de quem age, frase e autor. Sem `para` = evento informativo
// (checkout gerado, pedido editado, tentativa recusada): não é mudança de
// etapa, então não herda o rótulo de um estágio do workflow.
const HistoricoPedido = ({ historico = [] }) => {
  const eventos = [...historico].sort((a, b) => new Date(a.em || 0) - new Date(b.em || 0));
  if (eventos.length === 0) return <p className="text-sm text-gray-500">Sem eventos registrados.</p>;

  return (
    <ol className="relative">
      {eventos.map((ev, idx) => {
        const isTransicao = Boolean(ev.para);
        const evCfg = isTransicao ? getWorkflowConfig(ev.para) : null;
        const recusado = /recusad|reprovad|falh|erro/i.test(ev.obs || '');
        const ponto = isTransicao ? evCfg.color : recusado ? DOT.bad : 'bg-gray-300 dark:bg-gray-600';
        // URLs em eventos informativos (ex.: tarefa Bitrix) viram link em vez do endereço cru.
        const partesObs = String(ev.obs || 'Evento').split(/(https?:\/\/\S+)/g);
        const titulo = isTransicao
          ? evCfg.label
          : partesObs.map((parte, i) =>
              /^https?:\/\//.test(parte) ? (
                <a
                  key={i}
                  href={parte.replace(/[).,;]+$/, '')}
                  target="_blank"
                  rel="noreferrer"
                  className="text-blue-600 hover:underline dark:text-blue-400"
                >
                  abrir tarefa
                </a>
              ) : (
                parte
              )
            );
        return (
          <li key={idx} className="relative grid grid-cols-[46px_14px_minmax(0,1fr)] gap-x-2 py-2 text-sm">
            <time className="pt-px text-[12.5px] tabular-nums text-gray-500" dateTime={ev.em || undefined}>
              {formatHora(ev.em)}
            </time>
            <span aria-hidden className={`mt-1.5 h-2 w-2 rounded-full ${ponto}`} />
            {idx < eventos.length - 1 && (
              <span aria-hidden className="absolute bottom-[-6px] left-[55px] top-[26px] w-px bg-border" />
            )}
            <div className="min-w-0">
              <p className={isTransicao ? 'font-medium text-foreground' : 'text-gray-700 dark:text-gray-300'}>{titulo}</p>
              {isTransicao && ev.obs && <p className="text-[12.5px] text-gray-500">{ev.obs}</p>}
              <p className="text-[12px] text-gray-500">
                {ev.por_nome || 'Sistema'}
                {ev.em && ` · ${formatData(ev.em)}`}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default HistoricoPedido;
